var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{directives:[{name:"hi-has",rawName:"v-hi-has",value:(_vm.permission),expression:"permission"}],attrs:{"type":_vm.type,"icon":_vm.icon},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.L(_vm.labelKey)))])
}
var staticRenderFns = []

export { render, staticRenderFns }